module.exports = __webpack_public_path__ + "img/icon_write_data_search.17f0a601.svg";